import React from 'react';
import './GiftCardModal.css';
import solidcoreLogo from '../image/solidcore.png';

function GiftCardModal({ onClose, cardNumber }) {
  const handleClose = () => {
    // Close the modal first
    onClose();

    // Start cooldown after a small delay to ensure modal closes
    setTimeout(() => {
      if (window.startCooldown) {
        window.startCooldown();
      }
    }, 100);
  };

  return (
    <div className="gift-card-overlay" onClick={handleClose}>
      <div className="gift-card-modal" onClick={(e) => e.stopPropagation()}>
        <button className="gift-card-close-x" onClick={handleClose}>×</button>
        <div className="gift-card-header">
          <h2>🎉 Gift Card Activated!</h2>
        </div>
        <div className="gift-card-body">
          <div className="logo-container">
            <img src={solidcoreLogo} alt="solidcore" />
          </div>

          <div className="gift-card-details">
            <div className="gift-card-row">
              <span className="gift-card-label">Card Number</span>
              <span className="gift-card-value">{cardNumber}</span>
            </div>
            <div className="gift-card-row">
              <span className="gift-card-label">Value</span>
              <span className="gift-card-value">$50</span>
            </div>
          </div>

          <div className="gift-card-terms">
            Gift card holds no cash value and cannot be redeemed for cash. Certain restrictions of use may apply. To activate gift card, contact our team at solidcore@solidcore.co.
          </div>
        </div>
      </div>
    </div>
  );
}

export default GiftCardModal;
